import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { LOGIN_PAGE } from "../../assets/constant";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const url = state.url;

    if (!this.hasValidSession()) {
      this.redirectToLogin();
      return false;
    }

    const currentUserType = this.authService.getCurrentUserType();

    if (!currentUserType) {
      this.authService.signOut();
      return false;
    }

    if (this.isValidUserType(currentUserType)) {
      return true;
    } else {
      console.log(
        `Invalid user type: ${currentUserType} - redirecting to login`
      );
      this.authService.signOut();
      return false;
    }
  }

  private hasValidSession(): boolean {
    const isLoggedIn = this.authService.loggedIn();
    const hasCurrentUser = !!localStorage.getItem("currentUser");
    const hasTimestamp = !!localStorage.getItem("firebase_session_timestamp");

    const isValid = isLoggedIn && hasCurrentUser && hasTimestamp;

    return isValid;
  }

  private isValidUserType(userType: string): boolean {
    const validUserTypes = ["Admin", "Admin-Test"];
    return validUserTypes.includes(userType);
  }

  private redirectToLogin(): void {
    this.router.navigate([LOGIN_PAGE]);
  }
}
